import { createContext } from 'react'

export const EULAContext = createContext({ show: false })
